import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Space,
  Typography,
  PageHeader,
  Alert,
  Switch,
  Modal,
} from "antd";
import { ColorPicker } from "antd5";
import {
  MinusCircleOutlined,
  PlusOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  EditOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  ButtonItem,
  SwitchItem,
} from "../../../../Components/Items";
import ModalTransicionConfig from "../Components/ModalTransicionConfig";
import axios from "axios";
import { connect } from "react-redux";

const { Title } = Typography;

class VistaEmbudo extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    embudo: null,
    transiciones: [],

    // Para la Matriz
    modalTransicionVisible: false,
    transicionAEditar: null,
    celdaActiva: null,

    bloqueoActual: null, // Puede ser: 'ETAPAS' | 'TRANSICIONES' | null
  };

  componentDidMount() {
    const id = this.props.match.params.id;

    if (id === "nuevo") {
      this.setState(
        {
          embudo: null,
          transiciones: [],
        },
        () => {
          this.formRef.current?.setFieldsValue({
            etapas: [
              {
                nombre: "",
                color: "#1890ff",
                probabilidadExito: 0,
                diasDeVigencia: 0,
                diasParaAviso: 0,
                considerarGanado: false,
              },
            ],
          });
        },
      );
    } else {
      this.cargarDatos(id);
    }
  }

  cargarDatos = (idEmbudo) => {
    this.setState({ loading: true });

    axios
      .post(
        "embudos/datosEmbudo",
        { id: idEmbudo },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState(
            {
              embudo: res.data.embudo,
              transiciones: res.data.transiciones,
              bloqueoActual: null,
            },
            () => {
              this.formRef.current?.setFieldsValue(res.data.embudo);
            },
          );
        } else {
          Modal.error({ title: "Atención", content: res.data.message });
        }
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: "Error",
          content: "Ocurrió un error al cargar los datos.",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  guardarEmbudo = async () => {
    try {
      const values = await this.formRef.current.validateFields();
      for (let i = 0; i < (values.etapas || []).length; i++) {
        const etapa = values.etapas[i];
        const diasVigencia = etapa.diasDeVigencia;

        if (!diasVigencia || diasVigencia <= 0) {
          return Modal.warning({
            title: "Datos incompletos",
            content: `La etapa "${etapa.nombre || i + 1}" requiere días de vigencia mayor a 0.`,
          });
        }

        for (let j = 0; j < (etapa.avisos || []).length; j++) {
          const aviso = etapa.avisos[j];
          if (aviso.diasParaAviso >= diasVigencia) {
            return Modal.warning({
              title: "Aviso inválido",
              content: `En la etapa "${etapa.nombre || i + 1}", el aviso ${j + 1} tiene ${aviso.diasParaAviso} días, pero la vigencia es de ${diasVigencia} días. El aviso debe ser menor a la vigencia.`,
            });
          }
        }
      }
      this.setState({ loading: true });

      const payload = {
        ...values,
        _id: this.state.embudo?._id,
        transiciones: this.state.transiciones,
        empresaId: this.props.empresaId,
      };

      axios
        .post("embudos/guardarEmbudo", payload, {
          headers: this.props.headersToken,
        })
        .then((res) => {
          if (res.data.success === 2) {
            this.setState({
              embudo: res.data.embudo,
              transiciones: res.data.transiciones,
            });
            this.formRef.current?.setFieldsValue(res.data.embudo);
            Modal.success({ title: "Éxito", content: res.data.message });
            this.cargarDatos(res.data.embudo._id);
          } else {
            Modal.error({ title: "Error", content: res.data.message });
          }
        })
        .catch((err) => {
          console.error(err);
          Modal.error({ title: "Error", content: "Error de red al guardar." });
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    } catch (errorInfo) {
      console.error("Faltan campos obligatorios:", errorInfo);
      Modal.warning({
        title: "Faltan datos",
        content:
          "Por favor, completa los campos obligatorios marcados en rojo antes de guardar.",
      });
    }
  };

  normColor = (color) => {
    if (!color) return null;
    if (typeof color === "string") return color;
    if (typeof color.toHexString === "function") return color.toHexString();
    return null;
  };

  handleSwitchTransicion = (checked, origen, destino) => {
    if (!this.state.bloqueoActual) {
      this.setState({ bloqueoActual: "TRANSICIONES" });
    }
    const transicionExistente = this.state.transiciones.find(
      (t) =>
        t.estadoEmbudoOrigen === origen._id &&
        t.estadoEmbudoDestino === destino._id,
    );

    if (checked) {
      if (transicionExistente && transicionExistente.estado === 0) {
        this.setState((prev) => ({
          transiciones: prev.transiciones.map((t) =>
            t._id === transicionExistente._id ? { ...t, estado: 1 } : t,
          ),
        }));
      } else {
        this.setState({
          modalTransicionVisible: true,
          transicionAEditar: null,
          celdaActiva: {
            origenId: origen._id,
            destinoId: destino._id,
            origenNombre: origen.nombre,
            destinoNombre: destino.nombre,
          },
        });
      }
    } else {
      this.setState((prev) => ({
        transiciones: prev.transiciones.map((t) =>
          t._id === transicionExistente._id ? { ...t, estado: 0 } : t,
        ),
      }));
    }
  };

  editarTransicion = (transicion, origen, destino) => {
    this.setState({
      modalTransicionVisible: true,
      transicionAEditar: transicion,
      celdaActiva: {
        origenId: origen._id,
        destinoId: destino._id,
        origenNombre: origen.nombre,
        destinoNombre: destino.nombre,
      },
    });
  };

  guardarTransicionModal = (valores) => {
    this.setState((prev) => {
      let nuevasTrans;
      if (valores._id) {
        nuevasTrans = prev.transiciones.map((t) =>
          t._id === valores._id ? valores : t,
        );
      } else {
        nuevasTrans = [
          ...prev.transiciones,
          { ...valores, _id: `t_${Date.now()}` },
        ];
      }
      return {
        transiciones: nuevasTrans,
        modalTransicionVisible: false,
        celdaActiva: null,
        transicionAEditar: null,
      };
    });
  };

  atras() {
    this.props.history.goBack();
  }

  render() {
    const { embudo, transiciones, celdaActiva, bloqueoActual } = this.state;
    const etapasGuardadas = embudo?.etapas || [];
    const esEmbudoNuevo = !embudo?._id;

    const overlayStyle = {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.6)",
      backdropFilter: "blur(2px)",
      zIndex: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "8px",
      padding: "20px",
    };
    return (
      <div style={{ padding: "0 20px" }}>
        <ModalTransicionConfig
          visible={this.state.modalTransicionVisible}
          onCancel={() =>
            this.setState({
              modalTransicionVisible: false,
              celdaActiva: null,
              transicionAEditar: null,
            })
          }
          onSave={this.guardarTransicionModal}
          transicionAEditar={this.state.transicionAEditar}
          origenId={celdaActiva?.origenId}
          destinoId={celdaActiva?.destinoId}
          origenNombre={celdaActiva?.origenNombre}
          destinoNombre={celdaActiva?.destinoNombre}
        />

        <PageHeader
          title={
            esEmbudoNuevo
              ? "Construir Nuevo Embudo"
              : `Embudo: ${embudo.nombreEmbudo}`
          }
          subTitle="Diseña las etapas y configura cómo se mueven los prospectos."
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 15,
          }}
          extra={[
            <ButtonItem
              key="btn-guardar"
              verde
              onClick={this.guardarEmbudo}
              size="large"
              loading={this.state.loading}
              className="botonAgregar"
              icon={<SaveOutlined />}
            >
              Guardar Embudo y Matriz
            </ButtonItem>,
          ]}
          onBack={this.atras.bind(this)}
        />

        <Row gutter={16}>
          <Col span={10}>
            <div style={{ position: "relative", height: "100%" }}>
              {bloqueoActual === "TRANSICIONES" && (
                <div style={overlayStyle}>
                  <Alert
                    message="Edición de Etapas Bloqueada"
                    description="Estás modificando la matriz de movimientos. Haz clic en 'Guardar Embudo y Matriz' para aplicar los cambios y desbloquear esta sección."
                    type="warning"
                    showIcon
                  />
                </div>
              )}
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  border: "1px solid rgb(247, 247, 247)",
                }}
              >
                <Title level={4} style={{ marginBottom: 20 }}>
                  1. Etapas del Proceso
                </Title>

                <Form
                  ref={this.formRef}
                  name="form_embudo_builder"
                  layout="vertical"
                  onValuesChange={() => {
                    if (this.state.bloqueoActual !== "ETAPAS") {
                      this.setState({ bloqueoActual: "ETAPAS" });
                    }
                  }}
                >
                  <FormItem
                    name="nombreEmbudo"
                    label="Nombre del Embudo"
                    required
                    margin
                  >
                    <InputItem placeholder="Ej. Proceso de Ventas" />
                  </FormItem>

                  <Form.List name="etapas">
                    {(fields, { add, remove, move }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => (
                          <Card
                            size="small"
                            key={key}
                            style={{
                              marginBottom: 15,
                              background: "#f4f5f7",
                              border: "1px solid #dfe1e6",
                            }}
                            title={
                              <span
                                style={{ color: "#5e6c84", fontSize: "13px" }}
                              >
                                Etapa {index + 1}
                              </span>
                            }
                            extra={
                              <Space>
                                <ButtonItem
                                  type="default"
                                  size="small"
                                  icon={<ArrowUpOutlined />}
                                  cyan
                                  onClick={() => move(index, index - 1)}
                                  disabled={index === 0}
                                  lessTime
                                />
                                <ButtonItem
                                  type="default"
                                  size="small"
                                  naranja
                                  icon={<ArrowDownOutlined />}
                                  onClick={() => move(index, index + 1)}
                                  disabled={index === fields.length - 1}
                                  lessTime
                                />
                                <MinusCircleOutlined
                                  onClick={() => remove(name)}
                                  style={{
                                    color: "#ff4d4f",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    marginLeft: 8,
                                  }}
                                />
                              </Space>
                            }
                          >
                            <Row gutter={8}>
                              <Col span={17}>
                                <FormItem
                                  {...restField}
                                  name={[name, "nombre"]}
                                  label="Nombre Etapa"
                                  required
                                  margin
                                  wrapperCol={12}
                                  labelCol={12}
                                >
                                  <InputItem placeholder="Ej. Prospecto Inicial" />
                                </FormItem>
                              </Col>
                              <Col span={7}>
                                <FormItem
                                  {...restField}
                                  name={[name, "color"]}
                                  label="Color"
                                  required
                                  margin
                                  getValueFromEvent={this.normColor}
                                >
                                  <ColorPicker
                                    disabledAlpha
                                    format="hex"
                                    size="middle"
                                    showText
                                  />
                                </FormItem>
                              </Col>
                            </Row>
                            <Row gutter={8}>
                              <Col span={12}>
                                <FormItem
                                  {...restField}
                                  name={[name, "probabilidadExito"]}
                                  label="% Éxito"
                                  numberCero
                                  margin
                                  wrapperCol={12}
                                  labelCol={12}
                                >
                                  <InputNumberItem
                                    placeholder="0-100"
                                    max={100}
                                    min={0}
                                  />
                                </FormItem>
                              </Col>
                              <Col span={12}>
                                <FormItem
                                  {...restField}
                                  name={[name, "considerarGanado"]}
                                  label="Considerar Ganado"
                                  valuePropName="checked"
                                  margin={false}
                                  wrapperCol={12}
                                  labelCol={12}
                                >
                                  <SwitchItem />
                                </FormItem>
                              </Col>
                            </Row>

                            <Row gutter={8}>
                              <Col span={12}>
                                <FormItem
                                  {...restField}
                                  name={[name, "diasDeVigencia"]}
                                  label="Vigencia (Días)"
                                  numberCero
                                  margin
                                  required
                                  tooltip="Días antes de que el lead expire en esta etapa y desaparezca del dashboard."
                                  wrapperCol={12}
                                  labelCol={12}
                                >
                                  <InputNumberItem placeholder="Días" min={0} />
                                </FormItem>
                              </Col>
                            </Row>

                            <Form.List name={[name, "avisos"]}>
                              {(
                                avisosFields,
                                { add: addAviso, remove: removeAviso },
                              ) => (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginBottom: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: 12,
                                        color: "#5e6c84",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Avisos de vencimiento
                                    </span>
                                    <ButtonItem
                                      type="dashed"
                                      size="small"
                                      icon={<PlusOutlined />}
                                      onClick={() =>
                                        addAviso({
                                          diasParaAviso: 0,
                                          descripcion: "",
                                        })
                                      }
                                      style={{ fontSize: 11 }}
                                      disabled={avisosFields.length >= 5}
                                    >
                                      {avisosFields.length >= 5 ? 'Límite de 5 alcanzado' : 'Añadir aviso'}
                                    </ButtonItem>
                                  </div>

                                  {avisosFields.length === 0 && (
                                    <p
                                      style={{
                                        fontSize: 11,
                                        color: "#bfbfbf",
                                        marginBottom: 8,
                                      }}
                                    >
                                      Sin avisos configurados. Los avisos
                                      alertan al vendedor cuando el lead lleva N
                                      días en esta etapa.
                                    </p>
                                  )}

                                  {avisosFields.map(
                                    ({
                                      key: aKey,
                                      name: aName,
                                      ...aRestField
                                    }) => (
                                      <Row
                                        gutter={4}
                                        key={aKey}
                                        style={{
                                          display: "flex",
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        <Col span={8}>
                                          <FormItem
                                            {...aRestField}
                                            name={[aName, "diasParaAviso"]}
                                            numberCero
                                            margin={false}
                                            tooltip="Días desde que el lead entró a esta etapa"
                                            wrapperCol={12}
                                            labelCol={12}
                                          >
                                            <InputNumberItem
                                              placeholder="Días"
                                              min={1}
                                              onBlur={() => {
                                                const etapas =
                                                  this.formRef.current?.getFieldValue(
                                                    "etapas",
                                                  );
                                                const avisos =
                                                  etapas?.[index]?.avisos || [];
                                                avisos.forEach((_, aIndex) => {
                                                  this.formRef.current?.validateFields(
                                                    [
                                                      [
                                                        "etapas",
                                                        index,
                                                        "avisos",
                                                        aIndex,
                                                        "diasParaAviso",
                                                      ],
                                                    ],
                                                  );
                                                });
                                              }}
                                            />
                                          </FormItem>
                                        </Col>
                                        <Col span={12}>
                                          <FormItem
                                            {...aRestField}
                                            name={[aName, "descripcion"]}
                                            margin={false}
                                            wrapperCol={12}
                                            labelCol={12}
                                          >
                                            <InputItem placeholder="Descripción del aviso" />
                                          </FormItem>
                                        </Col>
                                        <Col
                                          span={2}
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            paddingTop: "4px",
                                          }}
                                        >
                                          <ButtonItem
                                            icon={<MinusCircleOutlined />}
                                            onClick={() => removeAviso(aName)}
                                            danger
                                          />
                                        </Col>
                                      </Row>
                                    ),
                                  )}
                                </>
                              )}
                            </Form.List>
                          </Card>
                        ))}

                        <ButtonItem
                          type="dashed"
                          onClick={() =>
                            add({
                              nombre: "",
                              color: "#1890ff",
                              probabilidadExito: 0,
                            })
                          }
                          block
                          icon={<PlusOutlined />}
                          style={{ marginBottom: 20 }}
                        >
                          Añadir Etapa
                        </ButtonItem>
                      </>
                    )}
                  </Form.List>
                </Form>
              </div>
            </div>
          </Col>

          <Col span={14}>
            <div style={{ position: "relative", height: "100%" }}>
              {bloqueoActual === "ETAPAS" && (
                <div style={overlayStyle}>
                  <Alert
                    message="Matriz Bloqueada Temporalmente"
                    description="Has hecho cambios en las etapas. Debes guardar el embudo primero para que las nuevas etapas se registren y puedas configurar sus movimientos."
                    type="warning"
                    showIcon
                  />
                </div>
              )}
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  border: "1px solid rgb(235, 237, 240)",
                  minHeight: "100%",
                }}
              >
                <Title level={4} style={{ color: "#172b4d", marginBottom: 10 }}>
                  2. Matriz de Movimientos
                </Title>
                <p
                  style={{
                    color: "#5e6c84",
                    fontSize: "13px",
                    marginBottom: 20,
                  }}
                >
                  Define qué movimientos están permitidos en el tablero. Las
                  filas representan la etapa actual, y las columnas la etapa a
                  la que se desea mover.
                </p>

                {esEmbudoNuevo || etapasGuardadas.length === 0 ? (
                  <Alert
                    message="Guarda el Embudo Primero"
                    description="Para configurar las transiciones, primero debes crear las etapas y darle al botón de Guardar Embudo en la columna izquierda."
                    type="warning"
                    showIcon
                  />
                ) : (
                  <div style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        border: "1px solid #f0f0f0",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              backgroundColor: "#fafafa",
                              padding: "12px",
                              border: "1px solid #f0f0f0",
                              color: "#172b4d",
                              fontSize: "12px",
                              textAlign: "left",
                              minWidth: "120px",
                            }}
                          >
                            Origen \ Destino ➔
                          </th>
                          {etapasGuardadas.map((destino) => (
                            <th
                              key={destino._id}
                              style={{
                                backgroundColor: "#fafafa",
                                padding: "12px",
                                border: "1px solid #f0f0f0",
                                textAlign: "center",
                                fontSize: "12px",
                                minWidth: "90px",
                              }}
                            >
                              <div
                                style={{
                                  color: destino.color,
                                  fontWeight: "bold",
                                }}
                              >
                                {destino.nombre}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {etapasGuardadas.map((origen) => (
                          <tr key={origen._id}>
                            <td
                              style={{
                                backgroundColor: "#fafafa",
                                padding: "12px",
                                border: "1px solid #f0f0f0",
                                fontWeight: "bold",
                                fontSize: "12px",
                                color: "#172b4d",
                              }}
                            >
                              {origen.nombre}
                            </td>
                            {etapasGuardadas.map((destino) => {
                              const isSame = origen._id === destino._id;
                              const transicion = transiciones.find(
                                (t) =>
                                  t.estadoEmbudoOrigen === origen._id &&
                                  t.estadoEmbudoDestino === destino._id &&
                                  t.estado !== 0,
                              );

                              return (
                                <td
                                  key={destino._id}
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #f0f0f0",
                                    textAlign: "center",
                                    backgroundColor: isSame
                                      ? "#f4f5f7"
                                      : "#fff",
                                  }}
                                >
                                  {isSame ? (
                                    <span
                                      style={{
                                        color: "#ccc",
                                        fontSize: "10px",
                                      }}
                                    >
                                      -
                                    </span>
                                  ) : (
                                    <Space>
                                      <Switch
                                        checked={!!transicion}
                                        onChange={(checked) =>
                                          this.handleSwitchTransicion(
                                            checked,
                                            origen,
                                            destino,
                                          )
                                        }
                                        size="small"
                                      />
                                      {transicion && (
                                        <EditOutlined
                                          style={{
                                            color: "#1890ff",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            this.editarTransicion(
                                              transicion,
                                              origen,
                                              destino,
                                            )
                                          }
                                        />
                                      )}
                                    </Space>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VistaEmbudo);
